import PrimerAssemblyOptionsView from 'assembly/tabs/primer-assembly/backbone/OptionsView';
import PrimerAssemblyTabView from 'assembly/tabs/primer-assembly/backbone/PrimerAssemblyTabView';

class GibsonTabOptionsView extends PrimerAssemblyOptionsView {}

class GibsonTabView extends PrimerAssemblyTabView {}

export {GibsonTabOptionsView as OptionsView, GibsonTabView as TabView};
